import { render } from "./VehicleRepairAction.vue?vue&type=template&id=5269b978"
import script from "./VehicleRepairAction.vue?vue&type=script&lang=js"
export * from "./VehicleRepairAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__